export const SYNC_SESSION_TIMEOUT_IN_MINUTES = 15
export const SYNCED_AVATARS_STORAGE_KEY = '@doris:sync_sai' // "SAI" stands for Synced Avatars IDs
export const SYNC_SESSION_STORAGE_KEY = '@doris:sync_session'
